import {
  createRoutesResourceGuard,
  deleteRoutesResourceGuard,
  editRoutesResourceGuard,
  routesCollectionGuard,
  routesResourceGuard,
} from './_api/logisticsRoutes';

export const resourceLogisticRoutes = routesResourceGuard;
export const deleteLogisticRoutes = deleteRoutesResourceGuard;
export const createLogisticRoutes = createRoutesResourceGuard;
export const collectionLogisticRoutes = routesCollectionGuard;
export const editLogisticRoutes = editRoutesResourceGuard;

export const routeGuard = routesCollectionGuard;
